var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('DynamicFormCore',{attrs:{"dynamicFormType":"breath_tonometry","answerableId":_vm.attendance.id,"answerableType":"Attendance"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }